import axios from "axios";

const ipAxios = axios.create({
  baseURL: "https://api64.ipify.org/?format=json",
  headers: { "Content-Type": "application/json" },
})

export const getIpAddressClient = async () => {
  return ipAxios.get<{ip: string}>('');
}